window.SplideManager = (function () {
  const sliders = {};

  function initSlider(container, config = {}) {
    if (!container || typeof Splide === "undefined") return;

    const id =
      container.getAttribute("data-slider-id") ||
      Math.random().toString(36).substr(2, 9);
    container.setAttribute("data-slider-id", id);

    // Destroy if already exists
    if (sliders[id]) {
      destroySlider(id);
    }

    const splide = new Splide(container, config);
    const parent =
      container.closest("[data-slider-wrapper]") || container.parentElement;
    const prevBtn = parent.querySelector(".custom-prev");
    const nextBtn = parent.querySelector(".custom-next");

    const onMount = () => {
      if (prevBtn) prevBtn.addEventListener("click", () => splide.go("<"));
      if (nextBtn) nextBtn.addEventListener("click", () => splide.go(">"));
    };

    splide.on("mounted", onMount);

    // 👇 Added logic to unfocus elements inside hidden slides
    // splide.on('moved', () => {
    //   const activeSlide = splide.Components.Slides.getAt(splide.index).slide;
    //   const focused = document.activeElement;
    //   if (focused && !activeSlide.contains(focused)) {
    //     focused.blur();
    //   }
    // });

    splide.mount();

    sliders[id] = {
      splide,
      prevBtn,
      nextBtn,
    };
  }

  function destroySlider(id) {
    const instance = sliders[id];
    if (!instance) return;

    const { splide, prevBtn, nextBtn } = instance;
    if (splide) splide.destroy(true);

    if (prevBtn) prevBtn.removeEventListener("click", () => splide.go("<"));
    if (nextBtn) nextBtn.removeEventListener("click", () => splide.go(">"));

    delete sliders[id];
  }

  function destroyAll() {
    Object.keys(sliders).forEach((id) => {
      destroySlider(id);
    });
  }

  return {
    initSlider,
    destroySlider,
    destroyAll,
  };
})();
